import { useState, useEffect } from "react";
import { Logo } from "./Logo";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { useLang } from "../i18n/LanguageContext";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Navbar = () => {
  const { t } = useLang();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { id: "servizi", label: t.nav.servizi },
    { id: "flotta", label: t.nav.flotta },
    { id: "contatti", label: t.nav.contatti },
  ];

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-[#0A0A0C]/85 backdrop-blur-xl border-b border-[#C5A059]/25" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3 group"
          data-testid="nav-home-btn"
        >
          <Logo className="h-9 w-auto text-[#C5A059]" strokeWidth={3} />
          <span className="font-serif text-xl tracking-tight text-white">
            Ncc <span className="font-light italic">Bologna</span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              data-testid={`nav-link-${l.id}`}
              className="relative text-sm text-zinc-300 hover:text-white transition-colors after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-white hover:after:w-full after:transition-all after:duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-5">
          <LanguageSwitcher />
          <button
            onClick={() => scrollTo("preventivo")}
            data-testid="nav-quote-btn"
            className="px-5 py-2.5 bg-[#C5A059] text-[#0A0A0C] text-xs font-medium uppercase tracking-[0.15em] hover:bg-[#d8b877] transition-colors"
          >
            {t.nav.preventivo}
          </button>
        </div>
      </div>
    </header>
  );
};
